var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.full)?_c('img',{style:({width: _vm.width, height: _vm.height}),attrs:{"src":require("@/assets/img/grapeperks/logo/imagotipo-uc.svg"),"alt":"GrapePerks"}}):_c('img',{style:({width: _vm.width, height: _vm.height}),attrs:{"src":require("@/assets/img/grapeperks/logo/isotipo.svg"),"alt":"GrapePerks"}})
}
var staticRenderFns = []

export { render, staticRenderFns }